"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubTaskInActiveStatePath = void 0;
const compare_task_status_1 = require("./compare-task-status");
/**
 * Make sure SubTask is active based on the Task status and version.
 * @param subTask The SubTask to check.
 * @param parent The parent Task of the provided {@linkcode subTask}.
 * @returns Determines if the {@linkcode subTask} is active.
 */
function isSubTaskInActiveStatePath(subTask, parent) {
    return ((!subTask.version ||
        !parent.version ||
        subTask.version === parent.version) &&
        (!subTask.statePath || compare_task_status_1.compareTaskStatus(subTask.statePath, parent.status)));
}
exports.isSubTaskInActiveStatePath = isSubTaskInActiveStatePath;
//# sourceMappingURL=is-sub-task-in-active-state-path.js.map